module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_9016.ea6d358f.png";